// Get an instance of `PhoneNumberUtil`.
const phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();

class PhoneService {
  validatePhone(input: string, code: string): boolean {
    //let result = phoneUtil.isValidNumberForRegion(phoneUtil.parse('202-456-1414', 'US'), 'US');

    if (code.length == 0) {
      return false;
    }

    let number;
    try {
      number = phoneUtil.parseAndKeepRawInput(input, code);
    } catch (error) {
      //console.log(error);
      return false;
    }

    return phoneUtil.isValidNumber(number);
  }

  splitNumber(input: string) {
    const number = [];
    try {
      // Parse number with country code and keep raw input.
      const numberProto = phoneUtil.parse(input, "");
      number.push(numberProto.getCountryCode());
      number.push(numberProto.getNationalNumber());
    } catch (error) {
      //console.log(error);
    }
    return number;
  }
}

export default new PhoneService();
